import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-past-recruiters',
  templateUrl: './past-recruiters.component.html',
  styleUrls: ['./past-recruiters.component.scss']
})
export class PastRecruitersComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
